<h2 mat-dialog-title>{{ isEditMode ? 'Edit User' : 'Create New User' }}</h2>

<mat-dialog-content>
  <form [formGroup]="userForm">
    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Username</mat-label>
      <input matInput formControlName="username" placeholder="Enter username" required>
      @if (userForm.get('username')?.hasError('required')) {
        <mat-error>Username is required</mat-error>
      }
    </mat-form-field>

    <mat-form-field appearance="outline" class="full-width">
      <mat-label>Password</mat-label>
      <input matInput type="password" formControlName="password"
             [placeholder]="isEditMode ? 'Leave empty to keep current password' : 'Enter password'"
             [required]="!isEditMode">
      @if (userForm.get('password')?.hasError('required')) {
        <mat-error>Password is required</mat-error>
      }
    </mat-form-field>

    @if (!isEditMode) {
      <mat-form-field appearance="outline" class="full-width">
        <mat-label>Base Role</mat-label>
        <mat-select formControlName="role" required>
          <mat-option value="Admin">Admin</mat-option>
          <mat-option value="Supplier">Supplier</mat-option>
          <mat-option value="Consumer">Consumer</mat-option>
        </mat-select>
        @if (userForm.get('role')?.hasError('required')) {
          <mat-error>Role is required</mat-error>
        }
      </mat-form-field>
    }
  </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
  <button mat-button (click)="onCancel()" [disabled]="submitting">Cancel</button>
  <button mat-raised-button color="primary" (click)="onSubmit()"
          [disabled]="userForm.invalid || submitting">
    {{ submitting ? 'Saving...' : (isEditMode ? 'Update' : 'Create') }}
  </button>
</mat-dialog-actions>
